import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import { Popconfirm, Table } from "antd";
import moment from "moment";
import { RequestAtc } from "../../redux/apiSlice/requestSlice";
import { IconPrimary } from "../../components";
import { BlockIcon } from "../../assets";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  cancelVoucher,
  getAtcVoucherByRequestId,
} from "../../redux/apiActions/voucherActions";
import { getVoucherState } from "../../redux/store/getState";
import { VOUCHER_STATUS } from "../../utils/status";
import useUser from "../../hooks/useUser";

type ColumnsType<T extends object = object> = TableProps<T>["columns"];

const ATCVoucherDetail: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const id = params.id;
  const { voucherByRequestId, loading } = useAppSelector(getVoucherState);
  const [data, setData] = useState<RequestAtc[]>();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const { user } = useUser();

  const isHaveEditPermission = user?.permissions?.includes("atc.edit");

  useEffect(() => {
    setData(voucherByRequestId);
  }, [voucherByRequestId]);

  useEffect(() => {
    dispatch(
      getAtcVoucherByRequestId({ atc_id: user?.atc.id, request_id: id })
    );
  }, [dispatch, id, user]);

  const columns: ColumnsType<RequestAtc> = [
    {
      title: "Date and Time",
      dataIndex: "created_at",
      render: (created_at) =>
        `${moment(created_at).format("DD/MM/YYYY hh:mmA")}`,
    },
    {
      title: "Username",
      dataIndex: "user",
      render: (user) => <>{user.username}</>,
    },

    {
      title: "Voucher Code",
      dataIndex: "id",
    },
    {
      title: "Expiry Date",
      dataIndex: "expiry_date",
      render: (expiry_date) =>
        `${moment.unix(expiry_date).format("DD/MM/YYYY hh:mmA")}`,
    },
    {
      title: "Voucher Status",
      dataIndex: "status",
      render: (status) => <>{VOUCHER_STATUS[status] || "-"}</>,
    },

    {
      title: "Action",
      render: (_, record) => (
        <Popconfirm
          title="Block the voucher"
          description="Are you sure to block the voucher?"
          onConfirm={() =>
            dispatch(
              cancelVoucher({ voucher_id: params.id || "", id: record.id })
            )
          }
          okText="Yes"
          cancelText="No"
        >
          <IconPrimary
            disabled={!isHaveEditPermission || record.status !== "created"}
          >
            <BlockIcon />
          </IconPrimary>
        </Popconfirm>
      ),
    },
  ];

  return (
    <>
      <Table
        style={{ marginTop: 20, whiteSpace: "pre" }}
        columns={columns}
        loading={loading.voucherByRequestId}
        rowKey={(record) => record.id}
        dataSource={data}
        onChange={(p) =>
          setPagination({ current: p.current || 1, pageSize: p.pageSize || 10 })
        }
        pagination={pagination}
        rowClassName={(_, index) => (index % 2 === 0 ? "tr-light" : "tr-dark")}
      />
    </>
  );
};

export default ATCVoucherDetail;
